import { z } from 'zod/v4';

export const CONSENT_STORAGE_VERSION = 1;
export const CONSENT_TTL_MS = 30 * 24 * 60 * 60 * 1000;
export const CONSENT_STORAGE_KEY = 'landing:privacy-consent:v1';

export const LandingConsentRecordSchema = z.object({
  agreedAt: z.number(),
  optional: z.boolean(),
  required: z.boolean(),
  version: z.literal(CONSENT_STORAGE_VERSION),
});
export type LandingConsentRecord = z.infer<typeof LandingConsentRecordSchema>;

const isConsentExpired = (agreedAt: number) => {
  return Date.now() - agreedAt > CONSENT_TTL_MS;
};

export const readLandingConsent = (): LandingConsentRecord | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    const raw = window.localStorage.getItem(CONSENT_STORAGE_KEY);
    if (!raw) {
      return null;
    }

    const parsed = LandingConsentRecordSchema.safeParse(JSON.parse(raw));
    if (!parsed.success) {
      return null;
    }

    if (isConsentExpired(parsed.data.agreedAt)) {
      window.localStorage.removeItem(CONSENT_STORAGE_KEY);
      return null;
    }

    return parsed.data;
  } catch {
    return null;
  }
};

export const writeLandingConsent = (record: LandingConsentRecord) => {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    window.localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(record));
  } catch {
    // ignore persistence failures
  }
};

export const isOptionalAnalyticsGranted = () => {
  return readLandingConsent()?.optional === true;
};
